import httpClient from '@/http-client'

export const expenseItem = (Options = {}) => {
  return httpClient
    .post('/api/v1/reports/finances/yearly-expense-items', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const expenseItemExcel = data => {
  return httpClient
    .post('/api/v1/reports/finances/yearly-expense-items/excels', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}

export const getExpenseItem = (Options = {}) => {
  return httpClient
    .get('/api/v1/reports/finances/expense-items', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const dailyExpensePdf = (Options = {}) => {
  return httpClient
    .post('/api/v1/reports/expense/daily-expenses/pdf', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const dailyExpenseExcel = data => {
  return httpClient
    .post('/api/v1/reports/expense/daily-expenses/excels', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}
export const expenseCategory = (Options = {}) => {
  return httpClient
    .get('/api/v1/reports/expense/daily-expenses/expense-categories', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const expItem = (Options = {}) => {
  return httpClient
    .get('/api/v1/reports/expense/daily-expenses/expense-items', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const dailyCashAdvancePdf = (Options = {}) => {
  return httpClient
    .post('/api/v1/reports/expense/daily-cash-advances/pdf', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const dailyCashAdvanceExcel = data => {
  return httpClient
    .post('/api/v1/reports/expense/daily-cash-advances/excels', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}

export const category = (Options = {}) => {
  return httpClient
    .get('/api/v1/reports/finances/categories', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const employee = (Options = {}) => {
  return httpClient
    .get('/api/v1/reports/finances/employees', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const monthlyExpenseItem = (Options = {}) => {
  return httpClient
    .post('/api/v1/reports/finances/monthly-expense-items', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const monthlyExpenseItemExcel = data => {
  return httpClient
    .post('/api/v1/reports/finances/monthly-expense-items/excels', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}
export const expCategory = (Options = {}) => {
  return httpClient
    .get('/api/v1/reports/finances/expense-categories', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export default {
  expenseItem,
  getExpenseItem,
  expenseItemExcel,
  dailyExpensePdf,
  dailyExpenseExcel,
  dailyCashAdvancePdf,
  dailyCashAdvanceExcel,
  monthlyExpenseItem,
  monthlyExpenseItemExcel,
  category,
  employee,
  expenseCategory,
  expCategory,
  expItem
}
